import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Election, NewElectionRequest, ElectionType } from '../interfaces/election';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ElectionApiService {

  private http = inject(HttpClient);
  private url = environment.apiUrl + 'election/';


  constructor() { }


  getElections(): Observable<any[]> {
    return this.http.get<Election[]>(this.url);
  }

  getElectionById(id: string): Observable<any> {
    return this.http.get<Election>(this.url + id);
  }

  getPastElections(id: string): Observable<any> {
    return this.http.get<Election>(`${this.url}${id}/past-elections`);
  }

  getElectionsByCampaignId(campaignId: string): Observable<any> {
    return this.http.get<Election[]>(this.url, {
                                                  params: {
                                                    campaignId: campaignId
                                                  }});
  }

  createElection(election: NewElectionRequest) {
    return this.http.post<any>(this.url, election);
  }

  getElectionTypeList() { 
    return this.http.get<ElectionType[]>(this.url + "types");
  }

}
